var map = {
	"./arg.svg": 2330,
	"./aus.svg": 2331,
	"./bel.svg": 2332,
	"./bra.svg": 2333,
	"./can.svg": 2334,
	"./cmr.svg": 2335,
	"./crc.svg": 2336,
	"./cro.svg": 2337,
	"./den.svg": 2338,
	"./ecu.svg": 2339,
	"./eng.svg": 2340,
	"./esp.svg": 2341,
	"./fra.svg": 2342,
	"./ger.svg": 2343,
	"./gha.svg": 2344,
	"./irn.svg": 2345,
	"./jpn.svg": 2346,
	"./kor.svg": 2347,
	"./ksa.svg": 2348,
	"./mar.svg": 2349,
	"./mex.svg": 2350,
	"./ned.svg": 2351,
	"./pol.svg": 2352,
	"./por.svg": 2353,
	"./qat.svg": 2354,
	"./sen.svg": 2355,
	"./srb.svg": 2356,
	"./sui.svg": 2357,
	"./tun.svg": 2358,
	"./uru.svg": 2359,
	"./usa.svg": 2360,
	"./wal.svg": 2361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;